import { useField } from 'formik';
import { Option } from 'types/types';
import { useTranslation } from 'react-i18next';
import SelectDataField from 'components/v2/form/select-data-field/SelectDataField';

interface PaymentTermsProps {
  isDisabled: boolean;
}

const PaymentTerms: React.FC<PaymentTermsProps> = ({ isDisabled }) => {
  const { t } = useTranslation();
  const [field, , helpers] = useField('termsOfPaymentOption');

  const daysOptions = [
    { value: '0', label: '0 days' },
    { value: '10', label: '10 days' },
    { value: '15', label: '15 days' },
    { value: '30', label: '30 days' },
    { value: '45', label: '45 days' },
    { value: '60', label: '60 days' },
    { value: '90', label: '90 days' },
  ] as Option[];

  return (
    <SelectDataField
      label={t('paymentTerms')}
      placeholder={t('placeholder.select')}
      name="termsOfPaymentOption"
      required
      isMulti={false}
      disabled={isDisabled}
      options={daysOptions.map((d) => {
        return { value: d.value, label: d.value } as Option;
      })}
      value={field.value}
      onChange={(value: Option | null) => {
        helpers.setValue(value);
      }}
      shouldShowBottomError={(err) => err !== t('messages.required')}
    />
  );
};

export default PaymentTerms;
